import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

export default {
  methods: {
    resetJson: function resetJson() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.$alert('确定重置玩法与代码字？', '警告', {
                  confirmButtonText: '确定',
                  callback: function () {
                    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(val) {
                      var loading;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (!(val === 'confirm')) {
                                _context.next = 14;
                                break;
                              }

                              loading = _this.$loading({
                                lock: true,
                                text: '重置玩法与代码字中',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                              });
                              _context.prev = 2;
                              _context.next = 5;
                              return _this.$store.dispatch('creative/template/resetTemplate', { isResetAll: 2 });

                            case 5:
                              loading.close();
                              window.location.reload();
                              _context.next = 14;
                              break;

                            case 9:
                              _context.prev = 9;
                              _context.t0 = _context['catch'](2);

                              console.error(_context.t0);
                              _this.$message.error('重置玩法与代码字失败');
                              loading.close();

                            case 14:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this, [[2, 9]]);
                    }));

                    return function callback(_x) {
                      return _ref.apply(this, arguments);
                    };
                  }()
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  }
};